var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.509 182.625C298.002 195.132 277.752 195.118 265.259 182.625L191.884 109.25V480C191.884 497.688 177.572 512 159.884 512S127.884 497.688 127.884 480V109.25L54.509 182.625C42.009 195.125 21.759 195.125 9.259 182.625S-3.241 149.875 9.259 137.375L137.259 9.375C149.759 -3.125 170.009 -3.125 182.509 9.375L310.509 137.375C323.009 149.875 323.009 170.125 310.509 182.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLong);
export default __webpack_public_path__ + "static/media/arrow-up-long.4278274c86bdb36177ca9c6cf6c7a9d8.svg";
export { ForwardRef as ReactComponent };